export default __webpack_public_path__ + "static/media/UniversLTStd-BlackEx.d7eb607d.otf";